export const itemsCountPerPage = 10
export const pageRangeDisplayed = 5
export const pageSize = 10